import api from '@pray/shared/utils/api';

export interface SeriesStatsResponse {
  data: {
    total: number;
    published: number;
    draft: number;
  };
}

export interface SeriesStats {
  total: number;
  published: number;
  draft: number;
}

type GetSeriesStatsProps = {
  artistId: string;
};

export const getSeriesStats = async ({ artistId }: GetSeriesStatsProps): Promise<SeriesStats> => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/content-series/stats`;
  const response = await api.executeGetRequest<SeriesStatsResponse>(url);

  return response.data.data;
};
